import React, { useReducer, createContext, useContext } from 'react';
import AccordionItem from './AccordionItem';

const AccordionContext = createContext();

export function useAccordion() {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error('useAccordion must be used within an Accordion');
  }
  return context;
}

function accordionReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_ITEM': {
      const { id, allowMultiple } = action.payload;
      const isOpen = state.includes(id);

      if (allowMultiple) {
        return isOpen
          ? state.filter((itemId) => itemId !== id)
          : [...state, id];
      } else {
        return isOpen ? [] : [id];
      }
    }
    default:
      return state;
  }
}

export default function Accordion({ children, allowMultiple = false }) {
  const [openItems, dispatch] = useReducer(accordionReducer, []);

  const value = {
    openItems,
    dispatch,
    allowMultiple,
  };

  return (
    <AccordionContext.Provider value={value}>
      <div className="w-full space-y-1">
        {children}
      </div>
    </AccordionContext.Provider>
  );
}

export { AccordionItem };
